/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

// <div className="hello-world">
// 	<h1>
// 		Hello <span className="hello-world-name">World</span>TEST
// 	</h1>
// </div>
import { CustomDropdownIndicator } from './CustomDropdownIndicator'
import React, { useEffect, useState } from 'react'
import Select, { components } from "react-select";
import { forkJoin, of, timer } from 'rxjs';
import { useTranslation, initReactI18next } from "react-i18next";
import langKeysFile from './langKeys.json';
const HelloFoo = () => {
	const [showModalSave, setShowModalSave] = useState(false);
	const { t } = useTranslation();
	const [langKeysList, setLangKeysList] = useState(null);
	// const [langKeysValueList, setLangKeysValueList] = useState(null);
	const [minimumVolume, setminimumVolume] = useState(null);
	const [minimumVolumeId, setminimumVolumeId] = useState(null);
	// const [createDefaultUnitsArray, setCreateDefaultUnitsArray] = useState([
	// 	{
	// 		"defaultUnitVal": "m | cm",
	// 		"side": 0,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 1,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 2,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 3,
	// 		"shape": 0,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 3,
	// 		"shape": 1,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 4,
	// 		"shape": 1,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 5,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 6,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 3,
	// 		"shape": 2,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 1,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 2,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 3,
	// 		"shape": 3,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 7,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 8,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 9,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 10,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 11,
	// 		"shape": 4,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 2,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 12,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "m",
	// 		"side": 13,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	{
	// 		"defaultUnitVal": "cm",
	// 		"side": 14,
	// 		"shape": 5,
	// 		"systemUnit": 0
	// 	},
	// 	/// ft | in
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 1,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 2,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 3,
	// 		"shape": 0,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 3,
	// 		"shape": 1,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 4,
	// 		"shape": 1,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 5,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 6,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 3,
	// 		"shape": 2,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 1,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 2,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 3,
	// 		"shape": 3,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 7,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 8,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 9,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 10,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 11,
	// 		"shape": 4,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 2,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 12,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "ft",
	// 		"side": 13,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	},
	// 	{
	// 		"defaultUnitVal": "in",
	// 		"side": 14,
	// 		"shape": 5,
	// 		"systemUnit": 1
	// 	}
	// ]);
	const [optionsVisibleArray, setOptionsVisibleArray] = useState([]);
	const [lengthUnit, setLengthUnit] = useState('');
	const [widthUnit, setWidthUnit] = useState('');
	const [diameterUnit, setDiameterUnit] = useState('');
	const [heightUnit, setheightUnit] = useState('');
	const [outerDiameterUnit, setOuterDiameterUnit] = useState('');
	const [innerDiameterUnit, setInnerDiameterUnit] = useState('');
	const [outerWidthUnit, setOuterWidthUnit] = useState('');
	const [innerWidthUnit, setInnerWidthUnit] = useState('');
	const [outerLengthUnit, setOuterLengthUnit] = useState('');
	const [innerLengthUnit, setInnerLengthUnit] = useState('');
	const [depthUnit, setDepthUnit] = useState('');
	const [riseUnit, setRiseUnit] = useState('');
	const [runUnit, setRunUnit] = useState('');
	const [platformDepthUnit, setPlatformDepthUnit] = useState('');
	const [numberStairs, setNumberStairs] = useState(1);
	const [unitsM, setUnitsM] = useState(['m', 'cm', 'mm']);
	const [unitSystems, setUnitSystems] = useState(['m | cm', 'ft | in']);

	const [defaultUnitsList, setDefaultUnitsList] = useState(null);
	const [sides, setSides] = useState([
		{
			id: 1,
			side: 'length'
		},
		{
			id: 2,
			side: 'width'
		},
		{
			id: 3,
			side: 'height'
		},
		{
			id: 4,
			side: 'diameter'
		},
		{
			id: 5,
			side: 'outerDiameter'
		},
		{
			id: 6,
			side: 'innerDiameter'
		},
		{
			id: 7,
			side: 'outerWidth'
		},
		{
			id: 8,
			side: 'outerLength'
		},
		{
			id: 9,
			side: 'innerWidth'
		},
		{
			id: 10,
			side: 'innerLength'
		},
		{
			id: 11,
			side: 'depth'
		},
		{
			id: 12,
			side: 'rise'
		},
		{
			id: 13,
			side: 'run'
		},
		{
			id: 14,
			side: 'platformDepth'
		}]);
	const [selectedTab, setSelectedTab] = useState(0);
	const [selectedImage, setSelectedImage] = useState(0);
	const [images, setImages] = useState([
		{
			url: '',
			label: t('Square_Slab')
		},
		{
			url: '',
			label: t('Column')
		},
		{
			url: '',
			label: t('Tube')
		},
		{
			url: '',
			label: t('Wall')
		},
		{
			url: '',
			label: t('Strip_foundation')
		},
		{
			url: '',
			label: t('Stairs')
		}]);
	// const [urlBase, setUrlBase] = useState('http://localhost:8080/o/c/');
	// const [urlBase, setUrlBase] = useState('https://cxogdev-web.cemexgws.com/o/c/');
	// const [urlBase, setUrlBase] = useState('https://localhost:7213/api/');
	const [decimalsCount, setdecimalsCount] = useState(1);
	const [decimalsCountID, setdecimalsCountID] = useState('');
	const [urlBase, setUrlBase] = useState('https://cxapi-dev.cemexgws.com/api/');
	// const [dataReady, setDataReady] = useState(false);
	const [dataDefaultUnitsReady, setDataDefaultUnitsReady] = useState(false);
	// const [optionsReady, setOptionsReady] = useState(false);
	const [newProject, setNewProject] = useState('');
	const [newOption, setNewOption] = useState('');
	const [projectList, setProjectList] = useState(null);
	const [optionList, setOptionList] = useState(null);
	const [selectedUnitSystem, setSelectedUnitSystem] = useState(null);
	// const [selectedUnitSystem, setSelectedUnitSystem] = useState('m | cm');
	const [showModal, setShowModal] = useState(false);
	const [showModalLoading, setShowModalLoading] = useState(false);

	const [selectedUnitSystemModal, setSelectedUnitSystemModal] = useState(null);

	// const [projectList, setProjectList] = useState([
	// 	{
	// 		project: 'Foundations',
	// 		options: [
	// 			'Foundations Option 1',
	// 			'FoundationsOption 1'
	// 		]
	// 	},
	// 	{
	// 		project: 'House',
	// 		options: [
	// 			'House Option 1',
	// 			'House 1'
	// 		]
	// 	}]);
	const [siteId, setSiteId] = useState(null);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	// const isMobile = screenWidth <= 768;


	const [selectedDefaultLang, setSelectedDefaultLang] = useState(null);
	const [InitialLagList, setInitialLagList] = useState([
		{ label: "Arabic (Egypt)", value: "ar_EG" },
		{ label: "Arabic (Saudi Arabia)", value: "ar_SA" },
		{ label: "Czech (Czechia)", value: "cs_CZ" },
		{ label: "German (Germany)", value: "de_DE" },
		{ label: "English (United Kingdom)", value: "en_GB" },
		{ label: "English (United States)", value: "en_US" },
		{ label: "Spanish (Colombia)", value: "es_CO" },
		{ label: "Spanish (Spain)", value: "es_ES" },
		{ label: "Spanish (Guatemala)", value: "es_GT" },
		{ label: "Spanish (Mexico)", value: "es_MX" },
		{ label: "Spanish (Panama)", value: "es_PA" },
		{ label: "Spanish (Peru)", value: "es_PE" },
		{ label: "Spanish (Puerto Rico)", value: "es_PR" },
		{ label: "Spanish (El Salvador)", value: "es_SV" },
		{ label: "French (France)", value: "fr_FR" },
		{ label: "Croatian (Croatia)", value: "hr_HR" },
		{ label: "Hungarian (Hungary)", value: "hu_HU" },
		{ label: "Polish (Poland)", value: "pl_PL" }
	]);

	// const [InitialLagList, setInitialLagList] = useState([
	// 	"ar_EG: Arabic (Egypt)",
	// 	"ar_SA Arabic (Saudi Arabia)",
	// 	"cs_CZ Czech (Czechia)",
	// 	"de_DE German (Germany)",
	// 	"en_GB English (United Kingdom)",
	// 	"en_US English (United States)",
	// 	"es_CO Spanish (Colombia)",
	// 	"es_ES Spanish (Spain)",
	// 	"es_GT Spanish (Guatemala)",
	// 	"es_MX Spanish (Mexico)",
	// 	"es_PA Spanish (Panama)",
	// 	"es_PE Spanish (Peru)",
	// 	"es_PR Spanish (Puerto Rico)",
	// 	"es_SV Spanish (El Salvador)",
	// 	"fr_FR French (France)",
	// 	"hr_HR Croatian (Croatia)",
	// 	"hu_HU Hungarian (Hungary)",
	// 	"pl_PL Polish (Poland)"
	// ]);
	const isMobile = screenWidth <= 428;
	function handleWindowSizeChange() {
		setScreenWidth(window.innerWidth);
	}


	useEffect(() => {
		if (siteId == null) {
			var siteval = themeDisplay.getSiteGroupId();
			setSiteId(siteval);
		}

		if (langKeysList == null && siteId != null) {
			getLangKeysList();
		}

		//modal
		// var myModal = document.getElementById('myModal')
		// var myInput = document.getElementById('myInput')

		// myModal.addEventListener('shown.bs.modal', function () {
		// 	myInput.focus()
		// })

		if (minimumVolumeId == null && siteId != null) {
			getMinimumVolume();
		}

		if (defaultUnitsList == null && siteId != null) {
			getDefaultUnitsList(selectedImage);
		}
		// if (projectList == null && siteId != null) {
		// 	getProjectList();
		// 	getOptionsList();
		// }
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		}



	}, []);

	useEffect(() => {
		if (siteId != null) {
			getDefaultUnitsList(0);
		}
	}, [selectedUnitSystem]);

	useEffect(() => {
		if (langKeysList == null && siteId != null) {
			getLangKeysList();
		}

		if (minimumVolumeId == null && siteId != null) {
			getMinimumVolume();
		}

		if (defaultUnitsList == null && siteId != null) {
			getDefaultUnitsList(selectedImage);
		}
		// if (projectList == null && siteId != null) {
		// 	getProjectList();
		// 	getOptionsList();
		// }
	}, [siteId]);


	const customStyles = {
		control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
			...provided,
			background: '#FFFF',
			// display: 'flex',
			// flexWrap: 'nowrap',
			borderColor: '#3999FF',
			borderRadius: '7px',
			borderWidth: '1px',
			// width: '1px',
			fontWeight: 700,
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		menu: (provided) => ({ // 'menu' is from the div class too.
			...provided,
			fontWeight: 700,
			// background: 'transparent',
			background: '#FFFF',
			width: '92%',
			color: '#3999FF',
			// textDecorationColor: '#3999FF'
		}),
		singleValue: provided => ({
			...provided,
			color: '#3999FF',
			fontWeight: 700,
		}),
		placeholder: (baseStyles) => ({
			...baseStyles,
			// fontSize: "1em",
			// color: '#0003B1',
			fontWeight: 700,
			// borderColor: '#3999FF'
			color: '#3999FF',
		})
	};
	// const createDefaultUnitsInitLiferay = () => {
	// 	Liferay.Util.fetch(urlBase + 'defaultunits?pageSize=50', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var defaultUnitsList = response.items;
	// 		//console.log('defaultUnitsList.length', defaultUnitsList.length);
	// 		if (defaultUnitsList.length == 0) {
	// 			createDefaultUnitsArray.forEach(element => {
	// 				//console.log('JSON.stringify(element)', JSON.stringify(element));

	// 				Liferay.Util.fetch(urlBase + 'defaultunits/', {
	// 					body: JSON.stringify(element),
	// 					method: 'POST',
	// 					headers: {
	// 						'Content-Type': 'application/json',
	// 						// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 						// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 					}
	// 				}).then(function (response) {
	// 					return response.json();
	// 				}).then(function (response) {

	// 					setDefaultUnitsList(null);
	// 				});
	// 			});
	// 			//console.log('createDefaultUnitsInit DONE');
	// 		}
	// 	});

	// }


	const ChangeDefaultKeyDropDown = (key) => {
		setShowModalLoading(true);
		// console.log('ChangeDefaultKeyDropDown', key);
		setSelectedDefaultLang(key);
		changeLanguageKeysDefault(key);
	}

	const changeTab = (tab) => {
		setSelectedTab(tab);
	}

	const getDefaultUnitsList = (indexImage) => {
		fetch(urlBase + 'defaultunit/' + siteId, {
			// body: new FormData(form),
			method: 'GET'
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			var defaultUnitsList = response;

			if (defaultUnitsList != null && defaultUnitsList != 'null' && defaultUnitsList != undefined && defaultUnitsList.length > 0) {
				setDefaultUnitsList(defaultUnitsList);

				var defUnitSys = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0].defaultUnitVal;
				setSelectedUnitSystem(defUnitSys);

				if (defUnitSys == 'm | cm') {
					setUnitsM(['m', 'cm', 'mm']);
					// setUnitsM([{
					// 	label: 'm',
					// 	value: 'm'
					// },
					// {
					// 	label: 'cm',
					// 	value: 'cm'
					// }]);
				} else {
					setUnitsM(['ft', 'in', 'y']);
					// setUnitsM([{
					// 	label: 'ft',
					// 	value: 'ft'
					// },
					// {
					// 	label: 'in',
					// 	value: 'in'
					// }]);
				}

				var selSysUnit = 1;
				if (defUnitSys == 'm | cm') {
					selSysUnit = 0;
				}
				if (indexImage == 0) {
					var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setLengthUnit(lengthUnit);
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnit(widthUnit);
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnit(heightUnit);
				}
				if (indexImage == 1) {
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnit(heightUnit);
					var diameterUnit = defaultUnitsList.filter(c => c.side == 4 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setDiameterUnit(diameterUnit);
				}
				if (indexImage == 2) {
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnit(heightUnit);
					var d1 = defaultUnitsList.filter(c => c.side == 5 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterDiameterUnit(d1);
					var d2 = defaultUnitsList.filter(c => c.side == 6 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerDiameterUnit(d2);
				}
				if (indexImage == 3) {
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnit(widthUnit);
					var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setLengthUnit(lengthUnit);
					var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setheightUnit(heightUnit);
				}
				if (indexImage == 4) {
					var outerWidthUnit = defaultUnitsList.filter(c => c.side == 7 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterWidthUnit(outerWidthUnit);
					var outerLengthUnit = defaultUnitsList.filter(c => c.side == 8 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setOuterLengthUnit(outerLengthUnit);
					var innerWidthUnit = defaultUnitsList.filter(c => c.side == 9 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerWidthUnit(innerWidthUnit);
					var innerLengthUnit = defaultUnitsList.filter(c => c.side == 10 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setInnerLengthUnit(innerLengthUnit);
					var depthUnit = defaultUnitsList.filter(c => c.side == 11 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setDepthUnit(depthUnit);
				}
				if (indexImage == 5) {
					var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setWidthUnit(widthUnit);
					var riseUnit = defaultUnitsList.filter(c => c.side == 12 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setRiseUnit(riseUnit);
					var run = defaultUnitsList.filter(c => c.side == 13 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setRunUnit(run);
					var platformDepthUnit = defaultUnitsList.filter(c => c.side == 14 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
					setPlatformDepthUnit(platformDepthUnit);
				}

				//GetDecimalNumbers
				var decimalsCount = defaultUnitsList.filter(c => c.side == 999)[0]?.shape;

				if (decimalsCount != null && decimalsCount != undefined && decimalsCount != '') {
					setdecimalsCount(parseInt(decimalsCount));
				}

				var decimalsCountID = defaultUnitsList.filter(c => c.side == 999)[0]?.id;
				if (decimalsCountID != null && decimalsCountID != undefined && decimalsCountID != '') {
					setdecimalsCountID(decimalsCountID);
				}

				// var defunit = defaultUnitsList[0].defaultUnitVal;
				// if (defunit == 'm' || defunit == 'cm') {
				// 	setUnitsM(['m', 'cm']);
				// 	setSelectedUnitSystem('m | cm');
				// } else {
				// 	setUnitsM(['ft', 'in']);
				// 	setSelectedUnitSystem('ft | in');
				// }
			} else {
				setDefaultUnitsList([]);
			}
			setDataDefaultUnitsReady(true);
		})
	}

	// const getDefaultUnitsListLiferay = (indexImage) => {
	// 	Liferay.Util.fetch(urlBase + 'defaultunits?pageSize=50', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var defaultUnitsList = response.items;

	// 		if (defaultUnitsList != null && defaultUnitsList != 'null' && defaultUnitsList != undefined && defaultUnitsList.length > 0) {
	// 			setDefaultUnitsList(defaultUnitsList);

	// 			var defUnitSys = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0].defaultUnitVal;
	// 			setSelectedUnitSystem(defUnitSys);

	// 			if (defUnitSys == 'm | cm') {
	// 				setUnitsM(['m', 'cm']);
	// 			} else {
	// 				setUnitsM(['ft', 'in']);
	// 			}

	// 			var selSysUnit = 1;
	// 			if (defUnitSys == 'm | cm') {
	// 				selSysUnit = 0;
	// 			}
	// 			if (indexImage == 0) {
	// 				var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setLengthUnit(lengthUnit);
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnit(widthUnit);
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnit(heightUnit);
	// 			}
	// 			if (indexImage == 1) {
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnit(heightUnit);
	// 				var diameterUnit = defaultUnitsList.filter(c => c.side == 4 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setDiameterUnit(diameterUnit);
	// 			}
	// 			if (indexImage == 2) {
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnit(heightUnit);
	// 				var d1 = defaultUnitsList.filter(c => c.side == 5 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterDiameterUnit(d1);
	// 				var d2 = defaultUnitsList.filter(c => c.side == 6 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerDiameterUnit(d2);
	// 			}
	// 			if (indexImage == 3) {
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnit(widthUnit);
	// 				var lengthUnit = defaultUnitsList.filter(c => c.side == 1 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setLengthUnit(lengthUnit);
	// 				var heightUnit = defaultUnitsList.filter(c => c.side == 3 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setheightUnit(heightUnit);
	// 			}
	// 			if (indexImage == 4) {
	// 				var outerWidthUnit = defaultUnitsList.filter(c => c.side == 7 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterWidthUnit(outerWidthUnit);
	// 				var outerLengthUnit = defaultUnitsList.filter(c => c.side == 8 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setOuterLengthUnit(outerLengthUnit);
	// 				var innerWidthUnit = defaultUnitsList.filter(c => c.side == 9 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerWidthUnit(innerWidthUnit);
	// 				var innerLengthUnit = defaultUnitsList.filter(c => c.side == 10 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setInnerLengthUnit(innerLengthUnit);
	// 				var depthUnit = defaultUnitsList.filter(c => c.side == 11 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setDepthUnit(depthUnit);
	// 			}
	// 			if (indexImage == 5) {
	// 				var widthUnit = defaultUnitsList.filter(c => c.side == 2 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setWidthUnit(widthUnit);
	// 				var riseUnit = defaultUnitsList.filter(c => c.side == 12 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setRiseUnit(riseUnit);
	// 				var run = defaultUnitsList.filter(c => c.side == 13 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setRunUnit(run);
	// 				var platformDepthUnit = defaultUnitsList.filter(c => c.side == 14 && c.shape == indexImage && c.systemUnit == selSysUnit)[0].defaultUnitVal;
	// 				setPlatformDepthUnit(platformDepthUnit);
	// 			}

	// 			// var defunit = defaultUnitsList[0].defaultUnitVal;
	// 			// if (defunit == 'm' || defunit == 'cm') {
	// 			// 	setUnitsM(['m', 'cm']);
	// 			// 	setSelectedUnitSystem('m | cm');
	// 			// } else {
	// 			// 	setUnitsM(['ft', 'in']);
	// 			// 	setSelectedUnitSystem('ft | in');
	// 			// }
	// 		} else {
	// 			setDefaultUnitsList([]);
	// 		}
	// 		setDataDefaultUnitsReady(true);
	// 	})
	// }

	// const getProjectList = () => {
	// 	fetch(urlBase + 'project/' + siteId, {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		//console.log('response project ADMIN PANEL', response);
	// 		var projectList = response;

	// 		var optionsVisibleArrayTemp = [];
	// 		if (projectList != null && projectList != 'null' && projectList != undefined) {
	// 			projectList.forEach(element => {
	// 				optionsVisibleArrayTemp.push(false);
	// 			});
	// 			setProjectList(projectList);
	// 			setOptionsVisibleArray(optionsVisibleArrayTemp);
	// 		} else {
	// 			setProjectList([]);
	// 		}
	// 		setNewProject('');
	// 		setDataReady(true);
	// 	})
	// }

	// const getOptionsList = () => {
	// 	fetch(urlBase + 'projectoption/' + siteId, {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var optionsList = response;


	// 		if (optionsList != null && optionsList != 'null' && optionsList != undefined) {
	// 			setOptionList(optionsList);
	// 		} else {
	// 			setOptionList([]);
	// 		}
	// 		setNewOption('');
	// 		setOptionsReady(true);
	// 	})
	// }

	// const getProjectListLiferay = () => {
	// 	Liferay.Util.fetch(urlBase + 'projects/', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var projectList = response.items;

	// 		var optionsVisibleArrayTemp = [];
	// 		if (projectList != null && projectList != 'null' && projectList != undefined) {
	// 			projectList.forEach(element => {
	// 				optionsVisibleArrayTemp.push(false);
	// 			});
	// 			setProjectList(projectList);
	// 			setOptionsVisibleArray(optionsVisibleArrayTemp);
	// 		} else {
	// 			setProjectList([]);
	// 		}
	// 		setNewProject('');
	// 		setDataReady(true);
	// 	})
	// }

	// const getOptionsListLiferay = () => {
	// 	Liferay.Util.fetch(urlBase + 'options/', {
	// 		// body: new FormData(form),
	// 		method: 'GET'
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		var optionsList = response.items;


	// 		if (optionsList != null && optionsList != 'null' && optionsList != undefined) {
	// 			setOptionList(optionsList);
	// 		} else {
	// 			setOptionList([]);
	// 		}
	// 		setNewOption('');
	// 		setOptionsReady(true);
	// 	})
	// }


	const getLangKeysList = () => {
		fetch(urlBase + 'LangKey/' + siteId, {
			// body: new FormData(form),
			method: 'GET'
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			//console.log('response get LangKey', response);
			setLangKeysList(response);
		});
	}


	// const getOptionsListFiltered = (id) => {
	// 	// var opList = optionList;
	// 	var optionsFiltered = [];
	// 	optionList.forEach(element => {

	// 		if (element.projectId == id) {
	// 			optionsFiltered.push(element);

	// 		}
	// 	});
	// 	return optionsFiltered;
	// };

	// const getOptionsListFilteredLiferay = (id) => {
	// 	// var opList = optionList;
	// 	var optionsFiltered = [];
	// 	optionList.forEach(element => {

	// 		if (element.r_project_c_projectId == id) {
	// 			optionsFiltered.push(element);

	// 		}
	// 	});
	// 	return optionsFiltered;
	// };


	// const addProject = () => {
	// 	var body = {
	// 		"id": '00000000-0000-0000-0000-000000000000',
	// 		"name": newProject,
	// 		"siteId": siteId
	// 	};
	// 	fetch(urlBase + 'project/', {
	// 		// body: new FormData(form),
	// 		body: JSON.stringify(body),
	// 		method: 'POST',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		getProjectList();
	// 	})

	// 	// var newArray = [];
	// 	// // var configData = JSON.stringify(localStorage.getItem("configData"));

	// 	// projectList.forEach(element => {
	// 	// 	newArray.push(element);
	// 	// });
	// 	// newArray.push({
	// 	// 	id: projectList.length + 1,
	// 	// 	project: newProject,
	// 	// 	options: []
	// 	// });
	// 	// // configData.push({
	// 	// // 	project: newProject,
	// 	// // 	options: []
	// 	// // })
	// 	// setProjectList(newArray);
	// 	// localStorage.setItem("configData", JSON.stringify(newArray));
	// 	// setNewProject('');
	// };

	// const getProjectName = (id) => {
	// 	var name = '';
	// 	projectList.forEach(element => {
	// 		if (element.id == id) {
	// 			name = element.name
	// 		}
	// 	});
	// 	return name;
	// };

	// const getOptionName = (id) => {
	// 	var name = '';
	// 	optionList.forEach(element => {
	// 		if (element.id == id) {
	// 			name = element.name
	// 		}
	// 	});
	// 	return name;
	// };

	// const addProjectOption = (id) => {
	// 	var body = {
	// 		"id": '00000000-0000-0000-0000-000000000000',
	// 		"name": newOption,
	// 		"projectId": id,
	// 		"siteId": siteId
	// 		// "project": {
	// 		// 	id: id,
	// 		// 	name: getProjectName(id)
	// 		// },
	// 	};
	// 	fetch(urlBase + 'projectoption/', {
	// 		// body: new FormData(form),
	// 		body: JSON.stringify(body),
	// 		method: 'POST',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		getOptionsList();
	// 	})
	// 	// var newArray = [];
	// 	// projectList.forEach(element => {
	// 	// 	if (id == element.id) {
	// 	// 		// var optionslist = element.options;
	// 	// 		element.options.push(newOption);
	// 	// 	}
	// 	// 	newArray.push(element);
	// 	// });
	// 	// setProjectList(newArray);
	// 	// localStorage.setItem("configData", JSON.stringify(newArray));
	// 	// setNewOption('');
	// };

	const deleteProject = (id) => {
		fetch(urlBase + 'project/' + id, {
			// body: new FormData(form),
			// body: JSON.stringify(body),
			method: 'DELETE',
			// headers: {
			// 	'Content-Type': 'application/json',
			// 	// 'Authorization': `Bearer ${getTokenFromCookie()}`,
			// 	// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			// }
		}).then(function (response) {
			getProjectList();
		})
		// .then(function (response) {
		// 	getProjectList();
		// })

	};

	// const addProjectLiferay = () => {
	// 	var body = {
	// 		"name": newProject
	// 	};
	// 	Liferay.Util.fetch(urlBase + 'projects/', {
	// 		// body: new FormData(form),
	// 		body: JSON.stringify(body),
	// 		method: 'POST',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		getProjectList();
	// 	})

	// 	// var newArray = [];
	// 	// // var configData = JSON.stringify(localStorage.getItem("configData"));

	// 	// projectList.forEach(element => {
	// 	// 	newArray.push(element);
	// 	// });
	// 	// newArray.push({
	// 	// 	id: projectList.length + 1,
	// 	// 	project: newProject,
	// 	// 	options: []
	// 	// });
	// 	// // configData.push({
	// 	// // 	project: newProject,
	// 	// // 	options: []
	// 	// // })
	// 	// setProjectList(newArray);
	// 	// localStorage.setItem("configData", JSON.stringify(newArray));
	// 	// setNewProject('');
	// };

	// const deleteProjectLiferay = (id) => {
	// 	Liferay.Util.fetch(urlBase + 'projects/' + id, {
	// 		// body: new FormData(form),
	// 		// body: JSON.stringify(body),
	// 		method: 'DELETE',
	// 		// headers: {
	// 		// 	'Content-Type': 'application/json',
	// 		// 	// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 		// 	// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		// }
	// 	}).then(function (response) {
	// 		getProjectList();
	// 	})
	// 	// .then(function (response) {
	// 	// 	getProjectList();
	// 	// })

	// };


	const changeKeyValArray = (val, index) => {
		//console.log('changeKeyValArray val', val);
		var n = 0;
		var newArrayvals = [];
		langKeysList.forEach(element => {
			if (n == index) {
				newArrayvals.push(
					{
						id: element.id,
						language: element.language,
						key: element.key,
						keyValue: val,
						siteId: siteId
					}
				);
			} else {
				newArrayvals.push({
					id: element.id,
					language: element.language,
					key: element.key,
					keyValue: element.keyValue,
					siteId: siteId
				});
			}
			n++;
		});
		setLangKeysList(newArrayvals);
	};


	const saveLanguageKeys = () => {
		langKeysList.forEach(element => {
			var body = {
				id: element.id,
				language: element.language,
				key: element.key,
				keyValue: element.keyValue,
				siteId: siteId
			};

			fetch(urlBase + 'LangKey/' + element.id, {
				// body: new FormData(form),
				body: JSON.stringify(body),
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
					// 'Authorization': `Bearer ${getTokenFromCookie()}`,
					// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
				}
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				setShowModalSave(true);
				return response;
			});
		});

	};


	const viewOptionsClick = (id) => {
		var optionsVisibleArrayTemp = [];
		projectList.forEach(element => {
			if (id == element.id) {
				optionsVisibleArrayTemp.push(true);
			} else {
				optionsVisibleArrayTemp.push(false);
			}

		});
		setOptionsVisibleArray(optionsVisibleArrayTemp);

	};

	const deleteOption = (id) => {
		fetch(urlBase + 'projectoption/' + id, {
			// body: new FormData(form),
			// body: JSON.stringify(body),
			method: 'DELETE',
			// headers: {
			// 	'Content-Type': 'application/json',
			// 	// 'Authorization': `Bearer ${getTokenFromCookie()}`,
			// 	// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			// }
		}).then(function (response) {
			// return response.json();
			getOptionsList();
		})

	};

	// const deleteOptionLiferay = (id) => {
	// 	Liferay.Util.fetch(urlBase + 'options/' + id, {
	// 		// body: new FormData(form),
	// 		// body: JSON.stringify(body),
	// 		method: 'DELETE',
	// 		// headers: {
	// 		// 	'Content-Type': 'application/json',
	// 		// 	// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 		// 	// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		// }
	// 	}).then(function (response) {
	// 		// return response.json();
	// 		getOptionsList();
	// 	})

	// };

	const saveDefaultUnitsBatch = (shape) => {

		// {
		// 	id: 1,
		// 	side: 'length'
		// },
		// {
		// 	id: 2,
		// 	side: 'width'
		// },
		// {
		// 	id: 3,
		// 	side: 'height'
		// },
		// {
		// 	id: 4,
		// 	side: 'diameter'
		// },
		// {
		// 	id: 5,
		// 	side: 'outerDiameter'
		// },
		// {
		// 	id: 6,
		// 	side: 'innerDiameter'
		// },
		// {
		// 	id: 7,
		// 	side: 'outerWidth'
		// },
		// {
		// 	id: 8,
		// 	side: 'outerLength'
		// },
		// {
		// 	id: 9,
		// 	side: 'innerWidth'
		// },
		// {
		// 	id: 10,
		// 	side: 'innerLength'
		// },
		// {
		// 	id: 11,
		// 	side: 'depth'
		// },
		// {
		// 	id: 12,
		// 	side: 'rise'
		// },
		// {
		// 	id: 13,
		// 	side: 'run'
		// },
		// {
		// 	id: 14,
		// 	side: 'platformDepth'
		// }
		var selSysUnit = 1;
		if (selectedUnitSystem == 'm | cm') {
			selSysUnit = 0;
		}
		if (shape == 0) {
			//implement side0
			// var idSide0 = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0].id;
			var idSide1 = defaultUnitsList.filter(c => c.side == 1 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide2 = defaultUnitsList.filter(c => c.side == 2 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide3 = defaultUnitsList.filter(c => c.side == 3 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide1, shape, lengthUnit, 1, selSysUnit),
				side2: saveDefaultUnits(idSide2, shape, widthUnit, 2, selSysUnit),
				side3: saveDefaultUnits(idSide3, shape, heightUnit, 3, selSysUnit)
			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
				},
			});
		}
		if (shape == 1) {
			var idSide3 = defaultUnitsList.filter(c => c.side == 3 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide4 = defaultUnitsList.filter(c => c.side == 4 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide3, shape, heightUnit, 3, selSysUnit),
				side2: saveDefaultUnits(idSide4, shape, diameterUnit, 4, selSysUnit),
			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
				},
			});
		}
		if (shape == 2) {
			var idSide3 = defaultUnitsList.filter(c => c.side == 3 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide5 = defaultUnitsList.filter(c => c.side == 5 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide6 = defaultUnitsList.filter(c => c.side == 6 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide5, shape, outerDiameterUnit, 5, selSysUnit),
				side2: saveDefaultUnits(idSide6, shape, innerDiameterUnit, 6, selSysUnit),
				side3: saveDefaultUnits(idSide3, shape, heightUnit, 3, selSysUnit),

			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
				},
			});
		}
		if (shape == 3) {
			var idSide1 = defaultUnitsList.filter(c => c.side == 1 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide2 = defaultUnitsList.filter(c => c.side == 2 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide3 = defaultUnitsList.filter(c => c.side == 3 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide1, shape, lengthUnit, 1, selSysUnit),
				side2: saveDefaultUnits(idSide2, shape, widthUnit, 2, selSysUnit),
				side3: saveDefaultUnits(idSide3, shape, heightUnit, 3, selSysUnit)
			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
				},
			});
		}
		if (shape == 4) {
			var idSide7 = defaultUnitsList.filter(c => c.side == 7 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide8 = defaultUnitsList.filter(c => c.side == 8 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide9 = defaultUnitsList.filter(c => c.side == 9 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide10 = defaultUnitsList.filter(c => c.side == 10 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide11 = defaultUnitsList.filter(c => c.side == 11 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide7, shape, outerWidthUnit, 7, selSysUnit),
				side2: saveDefaultUnits(idSide8, shape, outerLengthUnit, 8, selSysUnit),
				side3: saveDefaultUnits(idSide9, shape, innerWidthUnit, 9, selSysUnit),
				side4: saveDefaultUnits(idSide10, shape, innerLengthUnit, 10, selSysUnit),
				side5: saveDefaultUnits(idSide11, shape, depthUnit, 11, selSysUnit),

			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
				},
			});
		}
		if (shape == 5) {
			var idSide2 = defaultUnitsList.filter(c => c.side == 2 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide12 = defaultUnitsList.filter(c => c.side == 12 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide13 = defaultUnitsList.filter(c => c.side == 13 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			var idSide14 = defaultUnitsList.filter(c => c.side == 14 && c.shape == shape && c.systemUnit == selSysUnit)[0].id;
			const observable = forkJoin({
				// side0: saveDefaultUnits(idSide0, 0, 0, 0, selSysUnit),
				side1: saveDefaultUnits(idSide2, shape, widthUnit, 2, selSysUnit),
				side2: saveDefaultUnits(idSide12, shape, riseUnit, 12, selSysUnit),
				side3: saveDefaultUnits(idSide13, shape, runUnit, 13, selSysUnit),
				side4: saveDefaultUnits(idSide14, shape, platformDepthUnit, 14, selSysUnit),
			});
			observable.subscribe({
				next: value => {
					// ////console.log(value)
				},
				complete: () => {
					getDefaultUnitsList(selectedImage);
					setShowModalSave(true);
				},
			});
		}

	}

	const getMinimumVolume = () => {
		fetch(urlBase + 'minimumVolume/' + siteId, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Bearer ${getTokenFromCookie()}`,
				// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			}
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			setminimumVolume(response[0].minVal);
			setminimumVolumeId(response[0].id);
		});
	};


	// const getMinimumVolumeLiferay = () => {
	// 	var body = {
	// 		"minValue": 3,
	// 		// "defaultUnitVal": defaultUnit,
	// 		// "side": side,
	// 		// "systemUnit": systemUnit
	// 	};
	// 	return Liferay.Util.fetch(urlBase + 'minvolumes/', {
	// 		method: 'GET',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		if (response.items.length == 0) {
	// 			return Liferay.Util.fetch(urlBase + 'minvolumes/', {
	// 				// body: new FormData(form),
	// 				body: JSON.stringify(body),
	// 				method: 'POST',
	// 				headers: {
	// 					'Content-Type': 'application/json',
	// 					// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 					// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 				}
	// 			}).then(function (response) {
	// 				return response.json();
	// 			}).then(function (response) {
	// 				setminimumVolume(response.items[0].minValue);
	// 				setminimumVolumeId(response.items[0].id);
	// 			})
	// 		} else {
	// 			setminimumVolume(response.items[0].minValue);
	// 			setminimumVolumeId(response.items[0].id);
	// 		}
	// 	});
	// };

	const changeLanguageKeysDefault = (key) => {
		//console.log('selectedDefaultLang', selectedDefaultLang);
		// var selec = InitialLagList.filter(c => c.value == selectedDefaultLang);
		// //console.log('newLanList', newLanList);
		// //console.log('langKeysList', langKeysList);

		var listNewKeys = langKeysFile.filter(c => c.language == key)[0];
		//console.log('listNewKeys', listNewKeys);
		var newArrayLang = [];
		langKeysList.forEach(element => {
			var selkey = listNewKeys.items.filter(c => c.key == element.key)[0];
			//console.log('selkey', selkey);
			element.keyValue = selkey.value;
			newArrayLang.push(element);
		});
		setLangKeysList(newArrayLang);
		//console.log('newArrayLang', newArrayLang);
		setShowModalLoading(false);
	};

	const saveMinimumVolume = () => {
		var body = {
			"id": '00000000-0000-0000-0000-000000000000',
			"minVal": Number(minimumVolume),
			"siteId": siteId
		};
		return fetch(urlBase + 'minimumVolume/' + minimumVolumeId, {
			// body: new FormData(form),
			body: JSON.stringify(body),
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Bearer ${getTokenFromCookie()}`,
				// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			}
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			setShowModalSave(true);
			return response;
			// getProjectList();
		});


	};

	const saveDecimalsCount = () => {
		saveDefaultUnits(decimalsCountID, decimalsCount, '', 999, 0);
	};

	const saveDecimalsCountAndMinimumVolume = () => {
		saveDecimalsCount();
		saveMinimumVolume();
	};

	// const saveMinimumVolumeLiferay = () => {
	// 	var body = {
	// 		"minValue": Number(minimumVolume),
	// 		// "defaultUnitVal": defaultUnit,
	// 		// "side": side,
	// 		// "systemUnit": systemUnit
	// 	};
	// 	return Liferay.Util.fetch(urlBase + 'minvolumes/' + minimumVolumeId, {
	// 		// body: new FormData(form),
	// 		body: JSON.stringify(body),
	// 		method: 'PUT',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		return response;
	// 		// getProjectList();
	// 	});
	// };


	const saveDefaultUnits = (id, shape, defaultUnit, side, systemUnit) => {
		var body = {
			"id": '00000000-0000-0000-0000-000000000000',
			"shape": shape,
			"defaultUnitVal": defaultUnit,
			"side": side,
			"systemUnit": systemUnit,
			"siteId": siteId
		};
		return fetch(urlBase + 'defaultUnit/' + id, {
			// body: new FormData(form),
			body: JSON.stringify(body),
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				// 'Authorization': `Bearer ${getTokenFromCookie()}`,
				// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
			}
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			setShowModalSave(true);
			return response;
			// getProjectList();
		})
	};

	// const saveDefaultUnitsLiferay = (id, shape, defaultUnit, side, systemUnit) => {
	// 	var body = {
	// 		"shape": shape,
	// 		"defaultUnitVal": defaultUnit,
	// 		"side": side,
	// 		"systemUnit": systemUnit
	// 	};
	// 	return Liferay.Util.fetch(urlBase + 'defaultunits/' + id, {
	// 		// body: new FormData(form),
	// 		body: JSON.stringify(body),
	// 		method: 'PUT',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 			// 'Authorization': `Bearer ${getTokenFromCookie()}`,
	// 			// 'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
	// 		}
	// 	}).then(function (response) {
	// 		return response.json();
	// 	}).then(function (response) {
	// 		return response;
	// 		// getProjectList();
	// 	})
	// };



	const onImageChanged = (val) => {
		// var selImg = images.filter(c => c == val)[0];
		var index = 0;
		images.forEach(element => {
			if (element.label == val) {
				setSelectedImage(index);
				getDefaultUnitsList(index);
			}
			index++;
		});
	};

	const onChangeUnitSystem = (val) => {
		//console.log('onChangeUnitSystem', val);
		if (val == 'm | cm') {
			setUnitsM(['m', 'cm', 'mm']);
		} else {
			setUnitsM(['ft', 'in', 'y']);
		}
		setSelectedUnitSystem(val);

		//Save selectedUnit sistem (shape:0, side:0, systemUnit:0)
		var idSide0 = defaultUnitsList.filter(c => c.side == 0 && c.shape == 0 && c.systemUnit == 0)[0].id;
		saveDefaultUnits(idSide0, 0, val, 0, 0);
		setShowModal(false);
		window.location.reload();
	};


	const prepareShowModal = (val) => {
		// if (val == 'm | cm') {
		// 	setUnitsM(['m', 'cm']);
		// } else {
		// 	setUnitsM(['ft', 'in']);
		// }
		//console.log('setSelectedUnitSystemModal', val);
		setSelectedUnitSystemModal(val);
		setShowModal(true);
		//console.log('setShowModal(true)');

	};

	return (
		<div>
			{isMobile
				?
				//MOBILE VIEW 
				(
					<p>Mobile</p>
				)
				:
				// DESKTOP VIEW
				(
					<div className='row outfiter'>
						{
							showModal == true ? (
								// <div className="modal" tabindex="-1">
								<div className="liferay-modal-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">{t('Are_you_sure_you_want_to_change_the_unit_system?')}</h5>
											</div>
											<div className="modal-body">
												<p>{t('After_change_the_unit_system_all_the_shapes_default_units_will_change_to_the_selected_system_unit')}</p>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
													{t('Cancel')}
												</button>
												<button type="button" className="btn btn-primary" onClick={() => onChangeUnitSystem(selectedUnitSystemModal)}>
													{t('Change_unit_system')}
												</button>
											</div>
										</div>
									</div>
								</div>
							) : ('')
						}
						{
							showModalLoading == true ? (
								// <div className="modal" tabindex="-1">
								<div className="liferay-modal-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">Loading</h5>
											</div>
										</div>
									</div>
								</div>
							) : ('')
						}
						{
							showModalSave == true ? (
								// <div className="modal" tabindex="-1">
								<div className="liferay-modal-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title">Saved succesfully</h5>
											</div>
											{/* <div className="modal-body">
												<p>{t('After_change_the_unit_system_all_the_shapes_default_units_will_change_to_the_selected_system_unit')}</p>
											</div> */}
											<div className="modal-footer">
												{/* <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
													{t('Cancel')}
												</button> */}
												<button type="button" className="btn btn-primary" onClick={() => setShowModalSave(false)}>
													Close
												</button>
											</div>
										</div>
									</div>
								</div>
							) : ('')
						}
						<div className="row align-items-start justify-content-start mb-3 col-12">
							<p className='h3'>{t('Concrete_calculator')} - {t('admin_panel')}</p>
						</div>

						<div className="row align-items-start justify-content-start mb-3 col-12">
							<button type="button" className={selectedTab == 0 ? 'cmx-button-1-selected m-1' : 'cmx-button-1 m-1'}
								onClick={() => changeTab(0)}>Default Units</button>
							<button type="button" className={selectedTab == 1 ? 'cmx-button-1-selected m-1' : 'cmx-button-1 m-1'}
								onClick={() => changeTab(1)}>Language keys</button>
							<button type="button" className={selectedTab == 2 ? 'cmx-button-1-selected m-1' : 'cmx-button-1 m-1'}
								onClick={() => changeTab(2)}>Minimum volume & decimals count</button>

						</div>

						<div className="row align-items-start justify-content-start mb-3 col-12">
							{
								defaultUnitsList == null || defaultUnitsList.length == 0 ? (
									<button type="button" className="cmx-button-1 m-1" onClick={() => getDefaultUnitsList(0)}>{t('Get_default_units')}</button>
									// <button type="button" className="cmx-button-1 m-1" onClick={() => createDefaultUnitsInit()}>Create default units</button>
								) : (
									<div className='col-8'>
										{
											selectedTab == 0 ?
												(<div className='col-12'>
													<div className="row col-12 justify-content-start mb-2">
														<p className='h4 col-12'>{t('Default_units')}</p>
													</div>

													<div className="row col-12 justify-content-start mt-2 mb-2">
														<div className="row col-12">
															<p className='h5 col-4'>{t('Selected_unit_system')}:</p>
															<p className='h4 text-primary col-6'> {selectedUnitSystem}</p>
														</div>
														{
															selectedUnitSystem == 'm | cm' ? (
																<button type="button" className="cmx-button-1 m-2" onClick={() => prepareShowModal('ft | in')}>
																	{t('Change_to')}: ft | in
																</button>
															) : (
																<button type="button" className="cmx-button-1 m-2" onClick={() => prepareShowModal('m | cm')}>
																	{t('Change_to')}: m | cm
																</button>
															)
														}
													</div>

													<div className="row col-12 justify-content-start align-items-center">
														<label className='col-2 mb-1'>{t('Shape')}:</label>
														<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { onImageChanged(e.target.value) }}>
															<option className="option-style" selected>{t('Choose_an_option')}</option>
															{images.map((image, index) => (
																<option className="option-style" key={image.label} value={image.label} selected={index == selectedImage}>{image.label}</option>
															))}
														</select>
													</div>
													{
														selectedImage == 0 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Length')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setLengthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == lengthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Width')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setWidthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == widthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Height')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setheightUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == heightUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(0)}>Save</button>
																</div>
															</div>
														) : ('')
													}
													{
														selectedImage == 1 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Height')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setheightUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == heightUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Diameter')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setDiameterUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == diameterUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(1)}>Save</button>
																</div>
															</div>
														) : ('')
													}
													{
														selectedImage == 2 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Outer_diameter')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setOuterDiameterUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == outerDiameterUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Inner_diameter')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setInnerDiameterUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == innerDiameterUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Height')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setheightUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == heightUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(2)}>Save</button>
																</div>
															</div>
														) : ('')
													}
													{
														selectedImage == 3 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Width')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setWidthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == widthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Length')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setLengthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == lengthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Height')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setheightUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == heightUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(3)}>Save</button>
																</div>
															</div>
														) : ('')
													}
													{
														selectedImage == 4 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Outer_width')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setOuterWidthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == outerWidthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>Outer {t('Length')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setOuterLengthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == outerLengthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Inner_width')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setInnerWidthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == innerWidthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Inner_length')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setInnerLengthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == innerLengthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Depth')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setDepthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == depthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(4)}>Save</button>
																</div>
															</div>
														) : ('')
													}
													{
														selectedImage == 5 ? (
															<div className="row col-12 justify-content-start mt-2 mb-2">
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Width')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setWidthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == widthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Rise')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setRiseUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == riseUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Run')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setRunUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == runUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Platform_depth')}:</label>
																	<select className="cmx-form-control col-4 mt-2 mb-3" onChange={(e) => { setPlatformDepthUnit(e.target.value) }}>
																		<option className="option-style" selected>{t('Choose_an_option')}</option>
																		{unitsM.map((unit) => (
																			<option className="option-style" key={unit} value={unit} selected={unit == platformDepthUnit}>{unit}</option>
																		))}
																	</select>
																</div>
																<div className='col-12  align-items-center justify-content-start'>
																	<label className='col-2 mb-1'>{t('Number_of_stairs')}:</label>
																	<input
																		type="number"
																		className="cmx-form-control col-4"
																		id="numberStairs"
																		value={numberStairs}
																		onChange={(e) => { setNumberStairs(e.target.value) }}
																	/>
																</div>
																<div className='col  align-items-center justify-content-start mt-3'>
																	<button type="button" className="cmx-button-1 m-1" onClick={() => saveDefaultUnitsBatch(5)}>{t('Save')}</button>
																</div>
															</div>
														) : ('')
													}
												</div>) : ('')
										}


										{
											dataDefaultUnitsReady == true ? (
												<div className="row align-items-center justify-content-start mb-1">
													{
														selectedTab == 1 ? (
															<div className='col-12'>
																<div className="row col-12 justify-content-start mb-2">
																	<p className='h4 col-12'>{t('Language_keys')}</p>
																</div>
																<div className="row col-12 justify-content-start mt-2 mb-2">
																	<Select
																		className="select-style col-6"
																		closeMenuOnSelect={true}
																		// components={{ DropdownIndicator: CustomDropdownIndicator, IndicatorSeparator: () => null }}
																		placeholder={t('Choose_an_option')}
																		styles={customStyles}
																		options={InitialLagList}
																		onChange={(e) => { ChangeDefaultKeyDropDown(e.value) }}
																	/>
																	{/* <button type="button" className="cmx-button-1 ml-2" onClick={() => changeLanguageKeysDefault()}>
																		Set selected language
																	</button> */}
																</div>
																{langKeysList != null ? (
																	<div className="row col-12 justify-content-start mt-1 mb-2 lang-container">
																		{langKeysList.map((langkey, index) => (
																			<div className='col col-12 mb-2 align-items-center justify-content-start pb-2'>
																				<label className='col-4 mb-1 key-label'>{langkey.key}</label>
																				<input
																					className="cmx-form-control col-6"
																					id="langkeyinput"
																					value={langkey.keyValue}
																					onChange={(e) => { changeKeyValArray(e.target.value, index) }}
																				/>
																			</div>
																		))}
																	</div>
																) : (
																	<div className="row col-12 justify-content-start mt-2 mb-2">
																		<p className='h4 col-12'>NO LANG KEYS LOADED</p>
																	</div>
																)

																}
																<div className="row col-12 justify-content-start mb-2">
																	<button type="button" className="cmx-button-1 mt-3" onClick={() => saveLanguageKeys()}>{t('Save_language_keys')}</button>
																</div>
															</div>
														)
															: ('')
													}

													{
														selectedTab == 2 ? (
															<div className='col-12'>
																<div className="row col-12 justify-content-start mb-2">
																	<p className='h4 col-12'>{t('Minimum_volume')}</p>
																</div>
																<div className="row col-12 justify-content-start mt-2 mb-2">
																	<div className='row col-12 mb-2 align-items-center justify-content-start bottom-border-1 pb-2'>
																		<label className='col-12 mb-1'>{t('Permited_minimum_volume')}</label>
																		<input
																			className="cmx-form-control col-6 mr-3"
																			id="minimumvolume"
																			value={minimumVolume}
																			onChange={(e) => { setminimumVolume(e.target.value) }}
																		/>
																		{/* <button type="button" className="cmx-button-1 mt-3" onClick={() => saveMinimumVolume()}>{t('Save')}</button> */}
																	</div>
																</div>
																<div className="row col-12 justify-content-start mb-2">
																	<p className='h4 col-12'>Decimals Count</p>
																</div>
																<div className="row col-12 justify-content-start mt-2 mb-2">
																	<div className='row col-12 mb-2 align-items-center justify-content-start bottom-border-1 pb-2'>
																		<label className='col-12 mb-1'>Decimals Count</label>
																		<input
																			className="cmx-form-control col-6 mr-3"
																			id="decimalsCount"
																			value={decimalsCount}
																			onChange={(e) => { setdecimalsCount(e.target.value) }}
																		/>
																		{/* <button type="button" className="cmx-button-1 mt-3" onClick={() => saveDecimalsCountAndMinimumVolume()}>{t('Save')}</button> */}
																	</div>
																</div>
																<div className="row col-12 justify-content-start mt-2 mb-2">
																	<button type="button" className="cmx-button-1 mt-3" onClick={() => saveDecimalsCountAndMinimumVolume()}>{t('Save')}</button>
																</div>
															</div>
														) : ('')
													}
												</div>
											) : (
												''
											)
										}
									</div>
								)
							}
						</div>


					</div >
				)
			}
		</div >

	);
	// const [projectid, setProjectid] = useState('TEST002');

	// return (
	// 	<div className='row container'>
	// 		<div className='col-6'>
	// 			<form className="form-1">
	// 				<div className="row   align-items-center justify-content-start mb-3">
	// 					<p className='h1'>Calculate your volume {projectid}</p>
	// 				</div>
	// 			</form>
	// 		</div>
	// 	</div>
	// )

};

export default HelloFoo;
